import { cva, cx, type VariantProps } from 'class-variance-authority';

export const groupVariants = cva(
  'relative flex overflow-hidden justify-center items-center gap-1 rounded-md p-0.5 bg-neutral-50',
  {
    variants: {
      orientation: {
        horizontal: 'flex-row',
        vertical: 'flex-col',
      },
      readonly: {
        true: 'pointer-events-none',
        false: '',
      },
    },
    defaultVariants: {
      orientation: 'horizontal',
      readonly: false,
    },
  },
);

export const itemVariants = cva(
  [
    'gap-2 rounded-md px-2.5 label-xs text-neutral-300',
    'relative flex flex-col select-none items-center justify-center z-1',
    'cursor-pointer font-medium text-neutral-100',
    'not-data-disabled:[&_ml-icon]:text-neutral-900',
    'outline-none transition-colors duration-150',
    'not-data-disabled:not-data-selected:hover:bg-neutral-100/50',
    'data-disabled:cursor-not-allowed not-data-disabled:data-selected:text-neutral-900',
    'data-disabled:text-neutral-200 data-disabled:[&_ml-icon]:text-neutral-200',
  ],
  {
    variants: {
      onlyIcon: {
        true: 'size-12',
        false: 'h-19 w-29.5',
      },
    },
    defaultVariants: {
      onlyIcon: false,
    },
  },
);

export const slidingRectVariants = cx([
  'absolute pointer-events-none',
  'shadow-xs bg-white',
  'transition-all duration-150 ease-out-smooth rounded-sm',
]);

export type ToggleGroupVariants = VariantProps<typeof groupVariants>;
